module.exports = __webpack_public_path__ + "static/img/14.7700705.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/14.jpg
// module id = ER0V
// module chunks = 1